export const VIBRANT_IDENTIFIER_SYSTEM_SERVICES = "vibrant.services";
